export default "__VITE_ASSET__DnEGLprR__"